	
// Berichtsjahr
export class ReportingYear {
	[key: string]: string | number | boolean;

	bjAnpassungsfaktorVGV = 0;
	bjBis = 0;
	bjFreigabe = false;
	bjSichtbar = false;
	bjJahr = '';
	bjVon = 0;
}


// BerichtsjahrMitglied
export class ReportingYearMemberLink {

	mitgliedId = "";
	bjJahr = "";
	bjmId = "";

	bjmBearbeitbarBis = 0;
	bjmFreigabe = false;
	bjmAansprechpartner = "";
	bjmKommentar = "";

	anzahlMitglieder = 0;
	bjmEigenkapital = 0;
	bjmVerlustruecklage = 0;
	bjmGeschaetzt = false;
	
	daten: ReportingYearData[] = [];

}


// BerichtsjahrMitgliedDaten
export class ReportingYearData {
	[key: string]: string | number;

	bjmId = "";
	bmdId = "";
	sparteId = "";

	anzahlSchaedenBj = 0;
	anzahlVertraegeBj = 0;
	beitragBj1 = 0;
	beitragBj2 = 0;
	beitragFj = 0;
	rueckerStattungBj = 0;

	schadenkostenBj = 0;
	schadenzahlungenWeitereVj = 0;
	schadenreserveBj = 0;
	schadenreserveVj = 0;
	schadenzahlungenBj = 0;
	schadenzahlungenVj = 0;
	schadenreservWeitereVj = 0;

	versicherungssummeBj = 0;
	versicherungssummeFj = 0;
}
